import React, { FC } from "react";
/* eslint-disable max-len */
type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const SvgComponent: FC<IProps> = ({ width = 21, height = 22, color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 21 22" fill="none">
    <path
      d="M5.75 0.75V4.75M13.75 0.75V4.75M18.75 11.75V4.75C18.75 4.21957 18.5393 3.71086 18.1642 3.33579C17.7891 2.96071 17.2804 2.75 16.75 2.75H2.75C2.21957 2.75 1.71086 2.96071 1.33579 3.33579C0.960714 3.71086 0.75 4.21957 0.75 4.75V18.75C0.75 19.2804 0.960714 19.7891 1.33579 20.1642C1.71086 20.5393 2.21957 20.75 2.75 20.75H10.75M0.75 8.75H18.75M13.75 17.75H19.75M16.75 14.75V20.75"
      stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
